// routes/submit._index.tsx
import { getI18n } from 'src/i18n/i18n.middleware'
import { createHydratingClientLoader } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/submit._index'

const getClientModule = () => import('src/clientRoutes/submit._index')

export const handle = { name: 'submit' }

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('server:meta.home.title'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export const clientLoader =
  createHydratingClientLoader<Awaited<ReturnType<typeof loader>>>(
    getClientModule,
  )

export default function Page() {
  return null
}
